import axios, { AxiosInstance } from 'axios';

export interface ImageItem {
  filename: string;
  url: string;
  uploadedAt: number;
}

export interface ImageListResponse {
  images: ImageItem[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface UploadResponse {
  filename: string;
  url: string;
  size: number;
  mimetype: string;
}

export function imagesApi(token: string) {
  const client: AxiosInstance = axios.create({
    baseURL: 'https://img.beprime.pro',
    headers: { 'X-Admin-Key': token },
  });

  return {
    getList: (page = 1, limit = 24): Promise<ImageListResponse> =>
      client.get('/api/images', { params: { page, limit } }).then(r => r.data),

    upload: (file: File, onProgress?: (percent: number) => void): Promise<UploadResponse> => {
      const formData = new FormData();
      formData.append('image', file);
      return client
        .post('/api/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (e) => {
            if (onProgress && e.total) {
              onProgress(Math.round((e.loaded / e.total) * 100));
            }
          },
        })
        .then(r => r.data);
    },
  };
}
